<template>
	<!-- 负责人及成员信息 -->
	<div class="content">
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<h4 class="header-title mb-3">第二步：负责人及成员信息</h4>

						<div class="card-newProject">
							<p class="text-danger">说明：不能填写的部分，是从个人信息中读取的。</p>
							<!-- 表单 -->
							<el-form :model="peopleInfoForm" :rules="peopleInfoFormRules" ref="peopleInfoFormRef" label-width="110px" class="demo-peopleInfoForm">
								<el-row :gutter="20">
									<el-col :span="12"><el-form-item label="第一负责人">{{userinfo.realName}}</el-form-item></el-col>
									<el-col :span="12">
										<el-form-item label="性别" prop="gender">
											<el-select v-model="peopleInfoForm.gender" placeholder="请选择">
												<el-option v-for="item in genderOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>

								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label="民族" prop="nation"><el-input v-model="peopleInfoForm.nation"></el-input></el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="出生日期" prop="birthTime">
											<el-date-picker v-model="peopleInfoForm.birthTime" type="date" default-value="1985-01-01" placeholder="选择日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>
										</el-form-item>
									</el-col>
								</el-row>

								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label="行政职务" prop="administrativeDuties"><el-input v-model="peopleInfoForm.administrativeDuties"></el-input></el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="职称" prop="professionalSkillPostId">
											<el-select v-model="peopleInfoForm.professionalSkillPostId" placeholder="请选择">
												<el-option v-for="item in professionalSkillPostOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label="研究专长" prop="areasSpecialization"><el-input v-model="peopleInfoForm.areasSpecialization"></el-input></el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="最后学历" prop="lastDegreeId">
											<el-select v-model="peopleInfoForm.lastDegreeId" placeholder="请选择">
												<el-option v-for="(item, index) in lastDegreeOptions" :key="index" :label="item" :value="item"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label="最后学位" prop="lastQualificationId">
											<el-select v-model="peopleInfoForm.lastQualificationId" placeholder="请选择">
												<el-option v-for="(item, index) in lastQualificationOptions" :key="index" :label="item" :value="item"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="联系电话" prop="phone"><el-input v-model="peopleInfoForm.phone"></el-input></el-form-item>
									</el-col>
								</el-row>
								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label="单位名称" prop="unitName"><el-input v-model="peopleInfoForm.unitName" disabled></el-input></el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="电子邮箱" prop="email"><el-input v-model="peopleInfoForm.email"></el-input></el-form-item>
									</el-col>
								</el-row>
								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label="通讯地址" prop="address"><el-input v-model="peopleInfoForm.address"></el-input></el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="邮政编码" prop="postalCode"><el-input v-model="peopleInfoForm.postalCode"></el-input></el-form-item>
									</el-col>
								</el-row>

								<el-form-item v-if="projectData.twoEmceeState==1" label="第二负责人" prop="twoEmceeId">
									<el-input clearable @clear="clearUser" @focus="selectUser" v-model="peopleInfoForm.twoEmceeVal"></el-input>
								</el-form-item>

								<el-form-item label="核心组成员" prop="coreMember">
									<el-tag :key="index" v-for="(tag,index) in peopleInfoForm.coreMember" closable :disable-transitions="false" @close="handleClose(tag)">{{ tag }}</el-tag>
									<el-input
										class="input-new-tag"
										v-if="inputVisible"
										v-model="inputValue"
										ref="saveTagInput"
										size="small"
										@keyup.enter.native="handleInputConfirm"
										@blur="handleInputConfirm"
									></el-input>
									<el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Member</el-button>
									<p style="color:red;margin-bottom: 0;">（如果您的课题有多人共同研究，请填写成员姓名）</p>
								</el-form-item>

								<el-form-item>
									<el-button size="small" type="primary" @click="preStep">上一步</el-button>
									<el-button size="small" type="primary" @click="save">保存并下一步</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<!-- end card-body-->
				</div>
				<!-- end card -->
			</div>
			<!-- end col-->
		</div>

		<el-dialog title="请选择第二负责人" :visible.sync="userListDialogVisible" width="70%" :close-on-click-modal="false">
			<el-form :inline="true" ref="form" :model="userParams" label-width="80px">
			  <el-form-item label="真实姓名">
			    <el-input v-model="userParams.realName"></el-input>
			  </el-form-item>
				<!-- <el-form-item label="登录名">
				  <el-input v-model="userParams.username"></el-input>
				</el-form-item> -->
				<!-- <el-form-item label="区域">
				  <el-cascader placeholder="请选择区域" v-model="userParams.region" clearable :props="{ value: 'id', label: 'name' }" :options="areaOptions" @change="areaChange"></el-cascader>
				</el-form-item> -->
				<el-form-item label="单位">
				  <!-- <el-select v-model="userParams.unitId" :disabled="unitOptions.length===0" clearable filterable placeholder="请先选择区域">
				    <el-option v-for="item in unitOptions" :key="item.id" :label="item.unitName" :value="item.id"></el-option>
				  </el-select> -->
					<el-input v-model="userParams.unitName" placeholder="请输入单位名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="search">查询</el-button>
				</el-form-item>
			</el-form>
			<el-table border :data="userList" highlight-current-row @current-change="handleCurrentChange" style="width: 100%">
				<el-table-column type="index" width="50" label="#"></el-table-column>
				<el-table-column property="realName" label="姓名"></el-table-column>
				<el-table-column property="sex" label="性别">
					<template v-slot:default="scoped">
						{{scoped.row.sex == 1?'男':'女'}}
					</template>
				</el-table-column>
				<!-- <el-table-column property="username" label="用户名" width="120"></el-table-column> -->
				<!-- <el-table-column property="name" label="角色">
					<template slot-scope="scope">
						{{ scope.row.roleNames.join('、') }}
					</template>
				</el-table-column> -->
				<el-table-column property="unitName" label="单位"></el-table-column>
				<!-- <el-table-column property="address" label="状态">
					<template slot-scope="scope">
						{{ scope.row.status == 1 ? '可用' : '禁用' }}
					</template>
				</el-table-column> -->
			</el-table>
			
			<el-pagination
			  style="text-align: center;margin-top: 20px;"
			      @size-change="handleSizeChange"
			      @current-change="currentPageNumberChange"
			      :current-page="userParams.pageNumber"
			      :page-sizes="[10, 20, 50]"
			      :page-size="userParams.pageSize"
			      layout="total, sizes, prev, pager, next, jumper"
			      :total="userTotal">
			    </el-pagination>
			
			<span slot="footer" class="dialog-footer">
				<el-button @click="userListDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmUser">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { addOrEditTopicsDeclaration,getTopicsDeclarationById,isHasNotFinishTopic } from '@/api/after/projectApplication.js';
import { getPlatformInformationData, getUserList,getAreaTree,getUnitListByArea } from '@/api/after/systemManagement.js';
import {getUserInfo} from '@/api/after/login.js'
export default {
	props: {
		projectApplicationId: {
			type: String | Number,
			default: 0
		},
		topicDetail:{
			type:Object,
			default:null
		}
	},
	watch:{
		topicDetail:{
			handler(newVal){
				if (newVal) {
					console.log('接收到的数据',newVal);
					let data = JSON.parse(JSON.stringify(newVal))
					if (!data.coreMember) {
						data.coreMember = []
					}
					// 处理第二负责人数据
					if (data.twoEmceeName) {
						data.twoEmceeVal = `${data.twoEmceeName}(${data.unitName})`
					}
					// 删除不需要且会影响表单的属性
					delete data.expectedResearchResults
					delete data.keywords
					this.peopleInfoForm = data
				}
				this.userinfo = JSON.parse(sessionStorage.getItem('userInfo'));
				// this.peopleInfoForm.oneEmceeId = this.userinfo.id;
				// this.peopleInfoForm.oneEmceeName = this.userinfo.realName;
				// this.peopleInfoForm.unitId = this.userinfo.unitId;
				// this.peopleInfoForm.unitName = this.userinfo.unitName;
			},
			deep:true
		}
	},
	data() {
		var validatePhone = (rule, value, callback) => {
			let regexp = /^1[1-9]\d{9}$/;
			if (value === '') {
				callback(new Error('请输入联系电话'));
			} else if (regexp.test(value)) {
				callback();
			} else {
				callback(new Error('请输入正确的手机号码！'));
			}
		};
		var validateEmail = (rule, value, callback) => {
			let regexp = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
			if (value === '') {
				callback(new Error('请输入电子邮箱'));
			} else if (regexp.test(value)) {
				callback();
			} else {
				callback(new Error('请输入正确的电子邮箱！'));
			}
		};

		var validateMember = (rule, value, callback) => {
			if (value.length > this.$route.query.limit) {
				callback(new Error(`核心成员数不能超过项目规定的${this.$route.query.limit}人`));
			} else {
				callback();
			}
		};
		return {
			pickerOptions:{
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
			areaOptions:[],
			unitOptions:[],
			userParams: {
				pageNumber: 1,
				pageSize: 10,
				realName:'',//真实姓名
				region:'',//区域id
				unitId:'',//单位ID
				username:'',//用户名
				unitName:'',//单位名
			},
			userTotal: 0,
			userList: [], //用户列表
			userListDialogVisible: false,
			userinfo: {},
			projectData:{},
			peopleInfoForm: {
				oneEmceeId: '', //	第一负责人id
				oneEmceeName: '', //	第一负责人名称
				gender: '', //性别(0:女,1:男)
				nation: '', //民族
				birthTime: '', //出生日期
				administrativeDuties: '', //行政职务
				professionalSkillPostId: '', //职称id
				professionalSkillPostName: '', //职称名称
				areasSpecialization: '', //研究专长
				lastDegreeId: '', //最后学历id
				lastQualificationId: '', //最后学位id
				phone: '', //手机号码
				unitId: '', //单位id
				unitName: '', //单位名称
				email: '', //电子邮箱
				address: '', //通讯地址
				postalCode: '', //邮政编号
				twoEmceeId: '', //第二负责人id
				twoEmceeName: '', //第二负责人名称
				twoEmceeVal: '',
				coreMember: [] //核心组成员
			},
			inputVisible: false,
			inputValue: '',
			peopleInfoFormRules: {
				gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
				nation: [{ required: true, message: '请输入民族', trigger: 'blur' }],
				birthTime: [{ required: true, message: '请选择出生日期', trigger: 'change' }],
				professionalSkillPostId: [{ required: true, message: '请选择职称', trigger: 'change' }],
				areasSpecialization: [{ required: true, message: '请输入研究专长', trigger: 'blur' }],
				lastDegreeId: [{ required: true, message: '请选择最后学历', trigger: 'change' }],
				email: [{ required: true, validator: validateEmail, trigger: 'blur' }],
				phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
				coreMember: [{ required: false, validator: validateMember, trigger: 'blur' }]
			},
			genderOptions: [
				{
					label: '女',
					value: 0
				},
				{
					label: '男',
					value: 1
				}
			],
			professionalSkillPostOptions: [],
			lastDegreeOptions: ['高中及以下', '大学专科', '大学本科', '硕士研究生','博士研究生'],
			lastQualificationOptions: ['学士', '硕士', '博士'],
			curSelectUser: {} //当前选择用户
		};
	},
	created() {
		this.getAreaTree()
		this.getPlatformInformationData();
		this.projectData = JSON.parse(sessionStorage.getItem('projectData'));
		this.userinfo = JSON.parse(sessionStorage.getItem('userInfo'));
		// 获取第一负责人的信息
		this.peopleInfoForm.oneEmceeId = this.userinfo.id;
		this.peopleInfoForm.oneEmceeName = this.userinfo.realName;
		this.peopleInfoForm.unitId = this.userinfo.unitId;
		this.peopleInfoForm.unitName = this.userinfo.unitName;
		this.peopleInfoForm.gender = this.userinfo.sex
		this.peopleInfoForm.nation = this.userinfo.nation
		this.peopleInfoForm.birthTime = this.userinfo.birthday
		this.peopleInfoForm.administrativeDuties = this.userinfo.administrativePost
		this.peopleInfoForm.professionalSkillPostId = this.userinfo.professionalSkillPostId
		this.peopleInfoForm.professionalSkillPostName = this.userinfo.professionalSkillPostName
		this.peopleInfoForm.areasSpecialization = this.userinfo.areasSpecialization
		this.peopleInfoForm.lastDegreeId = this.userinfo.lastDegreeId
		this.peopleInfoForm.lastQualificationId = this.userinfo.lastQualificationId
		this.peopleInfoForm.phone = this.userinfo.mobile
		this.peopleInfoForm.email = this.userinfo.email
		this.peopleInfoForm.address = this.userinfo.address
		this.peopleInfoForm.postalCode = this.userinfo.postalCode
	},
	methods: {
		// 用户搜索
		search(){
			console.log(this.userParams);
			let params = JSON.parse(JSON.stringify(this.userParams))
			// params.region = params.region[params.region.length-1]
			params.pageNumber = 1
			console.log('处理后数据',params);
			this.getUserList(params)
		},
		// 获取区域树结构
		async getAreaTree() {
			const res = await getAreaTree();
			if (res.code == 200) {
				this.areaOptions = res.data;
			} else {
				this.$message.error(res.msg);
			}
		},
		// 区域选择并获取单位数据
		areaChange(val) {
			console.log(val);
			if (val&&val.length>0) {
				let areaId = val[val.length - 1];
				this.getUnitListByArea(areaId);
			}else{//情况地区时清空单位列表和选择的值
				this.unitOptions = []
				this.userParams.unitId = ''
			}
		},
		// 根据区域ID获取单位列表
		async getUnitListByArea(id) {
			const res = await getUnitListByArea(id);
			if (res.code == 200) {
				console.log('单位列表', res);
				this.unitOptions = res.data;
			} else {
				this.$message.error(res.msg);
			}
		},
		// 上一步
		preStep() {
			this.$emit('preStep', this.projectApplicationId);
		},
		// 提交表单
		save() {
			this.$refs.peopleInfoFormRef.validate(valid => {
				if (valid) {
					console.log(this.peopleInfoForm);
					let form = JSON.parse(JSON.stringify(this.peopleInfoForm));
					if(form.birthTime.length<11){
						form.birthTime=form.birthTime+' 00:00:00'
					}
					// 处理核心成员
					form.coreMember = form.coreMember.join(',');
					// 处理职称
					let professionalSkillPostObj = this.professionalSkillPostOptions.find(item=>{
						return item.id == form.professionalSkillPostId
					})
					form.professionalSkillPostName = professionalSkillPostObj.name
					// 删除多余数据
					// delete form.oneEmceeId;
					// delete form.oneEmceeName;
					// delete form.unitId;
					// delete form.unitName;
					// delete form.twoEmceeVal;
					//添加一些必要的数据
					form.projectId = this.$route.query.projectId;
					form.projectNumber = 2;
					if (this.projectApplicationId) {
						form.id = this.projectApplicationId;
					}
					console.log('修改之后的数据', form);
					this.addOrEditTopicsDeclaration(form);
				}
			});
		},
		// 选择用户
		selectUser() {
			this.userListDialogVisible = true;
			if (this.userList.length === 0) {
				this.userParams = {
					pageNumber: 1,
					pageSize: 10,
					realName:'',//真实姓名
					region:'',//区域id
					unitId:'',//单位ID
					username:'',//用户名
				};
				this.getUserList(this.userParams);
			}
		},
		// 清空用户
		clearUser() {
			this.peopleInfoForm.twoEmceeId = '';
			this.peopleInfoForm.twoEmceeName = '';
		},
		// 表格单选
		async handleCurrentChange(val) {
			const res = await isHasNotFinishTopic(val.id)
			if (res.code == 200) {
				this.curSelectUser = val;
				this.$message.success('当前用户可以选择！')
			}else{
				this.curSelectUser = {}
				this.$message.error(res.data+'，请重新选择！')
			}
		},
		// 确认用户
		confirmUser() {
			if (Object.keys(this.curSelectUser).length === 0) {
				this.$message.warning('请选择没有正在进行的课题的用户！')
				return 
			}
			this.peopleInfoForm.twoEmceeId = this.curSelectUser.id;
			this.peopleInfoForm.twoEmceeName = this.curSelectUser.realName;
			this.peopleInfoForm.twoEmceeVal = `${this.curSelectUser.realName}(${this.curSelectUser.unitName})`;
			this.userListDialogVisible = false;
		},
		async getUserList(data) {
			const res = await getUserList(data);
			if (res.code == 200) {
				console.log('用户列表', res);
				this.userList = res.data.records;
				this.userTotal = res.data.total;
			} else {
				this.$message.error(res.data);
			}
		},
		// 申报课题
		async addOrEditTopicsDeclaration(data) {
			const res = await addOrEditTopicsDeclaration(data);
			if (res.code == 200) {
				console.log('上传表单', res);
				this.$message.success('保存成功！')
				getUserInfo().then(res=>{
					if (res.code == 200) {
						console.log('用户信息',res);
						sessionStorage.setItem('userInfo',JSON.stringify(res.data))
					}else{
						this.$message.error(res.data)
					}
				})
				this.$emit('finish', res.data);
			} else {
				this.$message.error(res.data);
			}
		},
		//获取职称
		async getPlatformInformationData() {
			const res = await getPlatformInformationData(7);
			console.log('职称',);
			if (res.code == 200) {
				this.professionalSkillPostOptions = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		handleClose(tag) {
			this.peopleInfoForm.coreMember.splice(this.peopleInfoForm.coreMember.indexOf(tag), 1);
		},

		showInput() {
			this.inputVisible = true;
			this.$nextTick(_ => {
				this.$refs.saveTagInput.$refs.input.focus();
			});
		},

		handleInputConfirm() {
			if (this.inputValue.length > 4) {
				this.$message.error('名字不能超过4个字！');
				return;
			}
			let inputValue = this.inputValue;
			if (inputValue) {
				this.peopleInfoForm.coreMember.push(inputValue);
			}
			this.inputVisible = false;
			this.inputValue = '';
		},
		handleSizeChange(val){
			this.userParams.pageSize = val
			if (this.userParams.region) {
				this.userParams.region = this.userParams.region[this.userParams.region.length-1]
			}
			this.getUserList(this.userParams)
		},
		currentPageNumberChange(val){
			this.userParams.pageNumber = val
			if (this.userParams.region) {
				this.userParams.region = this.userParams.region[this.userParams.region.length-1]
			}
			this.getUserList(this.userParams)
		},
	}
};
</script>

<style scoped>
.el-tag + .el-tag {
	margin-left: 10px;
}
.button-new-tag {
	margin-left: 10px;
	height: 32px;
	line-height: 30px;
	padding-top: 0;
	padding-bottom: 0;
}
.input-new-tag {
	width: 90px;
	margin-left: 10px;
	vertical-align: bottom;
}
</style>
